import React from "react";
import { useParams } from "react-router-dom";
import { Typography } from "@mui/material";
import StationUsersPanel from "../../shared/components/StationUsersPanel";

const StationUsersSection: React.FC = () => {
  const { stationId } = useParams<{ stationId: string }>();

  return (
    <>
      <Typography variant="h6" fontWeight="bold" marginBottom={1}>
        Edit Station Users
      </Typography>
      <StationUsersPanel
        stationId={stationId!}
      />
    </>
  );
};

export default StationUsersSection;
